module.exports = __webpack_public_path__ + "static/media/CourseStatus_Incomplete.ddd14050.svg";